import { render } from "./InvoiceProductDetail.vue?vue&type=template&id=0ec23b41"
import script from "./InvoiceProductDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceProductDetail.vue?vue&type=script&lang=js"

import "./InvoiceProductDetail.vue?vue&type=style&index=0&id=0ec23b41&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__